export default (responseText) =>
{
  let responseJSON;

  try
  {
    responseJSON = JSON.parse(responseText);
  }
  catch (err)
  {
    responseJSON = null;
  }

  return { message: responseText, responseJSON };
};
